var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconProjectNew = function SvgIconProjectNew(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.458 16.183v-5.866L4.5 7.447v5.721q0 .064.032.12.032.057.096.097zm1.084 0 4.83-2.777a.3.3 0 0 0 .096-.097.24.24 0 0 0 .032-.12V7.468l-4.958 2.85zM10 9.365l5.104-2.932-4.997-2.86a.24.24 0 0 0-.128-.04.24.24 0 0 0-.128.04l-4.955 2.86zm-5.913 4.971a1.32 1.32 0 0 1-.67-1.155V6.82a1.31 1.31 0 0 1 .67-1.156l5.222-3.022q.315-.184.691-.184.377 0 .69.184l5.223 3.022a1.32 1.32 0 0 1 .67 1.156v6.362a1.31 1.31 0 0 1-.67 1.156L10.67 17.38a1.32 1.32 0 0 1-1.34 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconProjectNew);
export { ForwardRef as ReactComponent };